module.exports = __webpack_public_path__ + "img/work.deeb84d7.png";